'use client';

import { SomethingWentWrong } from '../components/common/error/something-went-wrong';

export default function GlobalErrorPage({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <SomethingWentWrong error={error} />
      </body>
    </html>
  );
}
